// extracted by mini-css-extract-plugin
export var component = "TextModule-module--component--cl0li";
export var content = "TextModule-module--content--QMe5M";
export var title = "TextModule-module--title--kLvX7";